<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form (submit)="rightSearch()" #form="ngForm" class="form-validate">
      <div class="row mb-3">
        <label class="col-form-label col-auto">
          <i class="bi bi-box me-2"></i>แหล่งข้อมูล
        </label>
        <div class="col-auto">
          <app-btn-lk2 [(source)]="source"></app-btn-lk2>
        </div>
      </div>
      <hr>
      <div class="row g-3 mb-3">
        <label for="personalId" class="col-form-label col-md-4 col-xl-auto">เลขประจำตัวประชาชน</label>
        <div class="col-md-6 col-xl-auto">
          <input type="text"
                 class="form-control"
                 id="personalId"
                 [(ngModel)]="personalId"
                 (click)="resetCheckDateTime()"
                 name="personalId"
                 required
                 pattern="(\d{13}|B.*|605.*)"
                 maxlength="13"
                 #personalIdInput="ngModel">
          @if (personalIdInput.invalid && (personalIdInput.dirty || personalIdInput.touched)) {
            <custom-error *ngIf="personalIdInput.hasError('required')" error="*จำเป็น"></custom-error>
            <custom-error *ngIf="personalIdInput.hasError('pattern')" error="*รูปแบบไม่ถูกต้อง"></custom-error>
          }
        </div>

        <label for="checkDate" class="col-form-label col-md-4 col-xl-auto">วันที่ตรวจสอบ/วันที่เข้ารับบริการ</label>
        <div class="col-auto">
          <gt-ng-datepicker [(ngModel)]="checkDate" [maxDate]="maxDate()" id="checkDate"
                            name="checkDate"></gt-ng-datepicker>
        </div>

        <label for="checkTime" class="col-form-label col-auto">เวลา</label>
        <div class="col-auto">
          <ngb-timepicker id="checkTime" name="checkTime" [(ngModel)]="checkTime" [spinners]="false"/>
        </div>
        <label for="checkTime" class="col-form-label col-auto">น.</label>

        <div class="offset-md-4 offset-xl-0 col-xl-auto">
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-search me-1"></i>ตรวจสอบสิทธิ
          </button>
          <button (click)="resetSearchParams()" type="button" class="btn btn-default mx-2">
            ล้างค่า
          </button>
        </div>
      </div>
      <gt-error code="Mod11"></gt-error>
    </form>
  </div>
</div>
<form>
  @if (data()?.personalData) {
    <app-right-detail [data]="data()"
                      (onTabChange)="onTabChange($event)"
                      [menu]="fromMenu()"
                      [source]="source()"></app-right-detail>
    @if (canBeRegistered() && !registrantType) {
      @if (showRegisterPanel()) {
        <ng-container
          *hasAnyAuthority="['admin', 'nhso', 'regis_zone', 'senior_regis', 'staff_call_center', 'regis_call_center']; except: ['chk_right', 'reg_chk_right']">
          <app-register-panel (onSelectRegistrantType)="register($event)"
                              [redirectUrl]="['/secure/registration/personal-id/forms']"></app-register-panel>
        </ng-container>
      }
    } @else if (registrantType) {
      <app-register-proxy [data]="data()" [registerMethod]="'PERSONAL_ID'"></app-register-proxy>
    }
  } @else {
    @if (!performSearch()) {
      <app-not-found></app-not-found>
    } @else {
      <div class="alert alert-danger mb-0" role="alert">
        <i class="bi bi-x-circle me-2"></i>ไม่พบข้อมูลที่ค้นหา
      </div>
    }
  }
</form>
